goog.provide("shadow.js.shim.module$src$svg$editor$formatting$list_svg");
goog.provide("module$shadow_js_shim_module$src$svg$editor$formatting$list_svg");
shadow.js.shim.module$src$svg$editor$formatting$list_svg = shadow.js.nativeProvides["src/svg/editor/formatting/list.svg"] = shadow$bridge("src/svg/editor/formatting/list.svg");
module$shadow_js_shim_module$src$svg$editor$formatting$list_svg.default = shadow.js.shim.module$src$svg$editor$formatting$list_svg;
